import React, {Fragment, useState, useRef, useEffect} from 'react';
import {Flex, Tabs, Progress, Card, Icon, Layout, Calendar, Breadcrumbs} from 'components';
import {sum, map, partial, returnNull, moment, useNamedSelector, pluralize} from 'helpers';
import css from './activities.module.scss';

export function ActivitiesStats() {
  const ref = useRef();
  const [position, setPosition] = useState(0);
  const [length, setLength] = useState(7);
  const [start, end] = useNamedSelector('calendar.range', {length, position});

  // const [stats, setState] = useState({completed: 0, total: 0});
  // useEffect(() => {
  //   const bars = ref.current.querySelectorAll('[role="progressbar"]');
  //   const sum = (prev, cur) => parseFloat(prev) + parseFloat(cur);
  //   setState({
  //     completed: map(bars, 'attributes.aria-valuenow.nodeValue').reduce(sum),
  //     total: map(bars, 'attributes.aria-valuemax.nodeValue').reduce(sum)
  //   });
  // }, [days]);

  return (
    <Fragment>
      <Layout.Header>
        <Breadcrumbs>
          Activities
          <b className="long">Completion Rate</b>
        </Breadcrumbs>
        <Tabs className="spacing">
          <Tabs.Tab onClick={() => setLength(7) || setPosition(0)} pressed={length === 7}>7 days</Tabs.Tab>
          <Tabs.Tab onClick={() => setLength(30) || setPosition(0)} pressed={length === 30}>30 days</Tabs.Tab>
          <Flex className="pull-right secondary">
            {start.range(end)}
            <Flex className={['small-gutter', 'black']}>
              <Icon onClick={() => setPosition(position - 1)} name="chevron-left" />
              <Icon onClick={() => setPosition(position + 1)} name="chevron-right" disabled={position === 0} />
            </Flex>
          </Flex>
        </Tabs>
      </Layout.Header>
      <div ref={ref}>
        <Calendar start={start} end={end} Day={Day} />
      </div>
    </Fragment>
  );
}

function Day({date, today}) {
  const isEditable = useNamedSelector('relations.isEditable');
  const list = useNamedSelector('calendar.day', { date });
  const total = list.filter(isEditable).filter(({ status }) => status != 'Skipped').length;
  const completed = list.filter(({ status }) => status == 'Completed').length;
  return (
    <Card>
      {date.isSame(today) &&
        <Card.Status containerClassName="sticky">Today</Card.Status>
      }
      <Card.Body>
        <div className={css.date}>
          <small>{ date.format('MMM') }</small>
          { date.format('D') }
        </div>
      </Card.Body>
      <Card.Progress position="above" now={completed} max={total}>
        <div className={css('stats', !total && 'invisible')}>{completed}/{total} {pluralize('activity', total)}</div>
      </Card.Progress>
    </Card>
  );
}
